import BasePropertyView from 'BasePropertyView.js';
import { Model } from 'backbone';
import eventBus from 'EventBus.js';
import utils from 'util/Util.js'
import listService      from 'ListService.js';
import Template from 'behaviors/properties/main/table-action.ejs';
import formulaModal from 'common-views/MainFormulaModalView.js';
import sortasc from 'editor/icons/sort_asc.png';
import sortdesc from 'editor/icons/sort_desc.png';

//=====================================================================
//
// An instance of this view represents a table action options.
//
// Casey Justus, May 15, 2016
//
//=====================================================================

class MainTableActionView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #addRowScreen, #text, #replace'  : 'showFormulaModal',
            'change input[name=action]'             : 'updateTableActionRadios',
            'change input[type=text]'               : 'updateAttributes',
            'blur input[type=text]'                 : 'lostFocus',
            'focus input[type=text]'                : 'getFocus',
            'change input[name=addRow],input[name=moveRow]': 'changeSubAction',
            'change #column'                         : 'changeColumnProperties',
            'change input[type=checkbox]'           :'changeConfirmationValue',
            'change #function'                      :'changeFunctionValue',
            'change #sortby'                          :'changeSortValue'
        };
        if(!this.model.get('tableSelection')){
            this.model.set('tableSelection', 'positionToAdd', {silent: true});
        }

        if (!this.model.get('Parameters')) {
            this.model.set('Parameters', {}, {silent: true});
            this.model.get('Parameters').Parameter = [];
        }

        if (!this.model.get('sortOrder')) {
            this.model.set('sortOrder', "ASC", {silent: true});
        }
    
        if (this.model.get('controlId')) {
            const id = this.model.get('controlId');
            const table = listService.getObject( listService.cleanId(id) );
            const columnList =  table ? table.model.get('gridData') : []; 
            this.columnList = columnList;
        }

        this.listenTo( eventBus, 'getColumnsOfSelectedTable', this.setColumnOfSelectedTable );
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    setColumnOfSelectedTable(table){
        this.columnList = table.model.get('gridData');
        this.fillColumnsSelect();
    }

    changeSubAction(event) {
        let val = event.target.value;
        const parentValue = $('input[name="action"]:checked').val();

        val = parentValue + val;

        this.model.set('action',val);
    }

    changeColumnProperties(event){

        const id = listService.getCleanedId( event.target.value );
        this.model.set(event.target.name, id);

        this.enableSortOptions(true);
    }

    changeFunctionValue(event) {
        this.model.set(event.target.name, event.target.value );
    }

    changeSortValue(event) {
        this.model.set(event.target.name, event.target.value, {silent: true} );
    }

    changeConfirmationValue(event){
        this.model.set('confirmation',event.target.checked);
    }

    updateTableActionRadios(event){

        let val = event.target.value;
        let subValue = '';

        switch (val) {
            case "add":
                subValue = $('input[name="addRow"]:checked').val();
                val = val + subValue;
                break;
            case "move":
                subValue = $('input[name="moveRow"]:checked').val();
                val = val + subValue;
                break;
        }


        this.model.set('action',val);
    }

    enableSelectionArea(){
        let selectedOption = this.model.get('action');
        if (selectedOption) {
            if (selectedOption.substring(0,3) === 'add') {
                selectedOption = 'add';
            }
            if (selectedOption.substring(0,4) === 'move') {
                selectedOption = 'move';
            }
        }

        let elementsToDisable=this.$el.find(`[data-value-type]`);
        elementsToDisable.map((index,element)=>{
            var elementValueType = $(element).attr('data-value-type');
            if( selectedOption !== elementValueType){
                element.setAttribute('disabled', 'disabled');
            } else {
                element.removeAttribute('disabled');
            }
        });
    }

    enableSortOptions(validate){
        const self = this;
        //PF-10797 check column type to enable sort
        const col = this.columnList.filter((c) =>{
            return c.get("id") === self.model.get('columnId');
        });

        if(col.length && col[0]){
            const textCols = ["dropdownColumn","textAreaColumn", "textInputColumn"];
            const numCols = ["numericInputColumn", "timeInputColumn"];
            const dateCols = ["dateInputColumn"];
            const factory = col[0].get("factoryKey");

            const selectedSortBy = $('#sortby').find(":selected").val();

            if(dateCols.includes(factory)){

                if(selectedSortBy !== "date" && validate){
                    this.model.set("sortby", "");
                }
                
                $(`option[value=Sort]`).prop('disabled',false);

                $(`option[value=alpha]`).prop('disabled',true);
                $(`option[value=numeric]`).prop('disabled',true);
                $(`option[value=date]`).prop('disabled',false);
            }else if(numCols.includes(factory)){
                
                if(selectedSortBy !== "numeric" && validate){
                    this.model.set("sortby", "");
                }

                $(`option[value=Sort]`).prop('disabled',false);

                $(`option[value=alpha]`).prop('disabled',true);
                $(`option[value=numeric]`).prop('disabled',false);
                $(`option[value=date]`).prop('disabled',true);
            }else if(textCols.includes(factory)){
                $(`option[value=Sort]`).prop('disabled',false);
                
                $(`option[value=alpha]`).prop('disabled',false);
                $(`option[value=numeric]`).prop('disabled',false);
                $(`option[value=date]`).prop('disabled',false);
            }
            else{ //If column type is not supported clear sort selection
                const functionType = $('#function').find(":selected").val();

                if(functionType === "Sort"){
                    this.model.set("function", "");
                    this.model.set("sortby", "");
                }
            }
        }
    }

    enableSortFx(){
        const self = this;
       
        $('#sortby').prop('disabled',false);
        $('#replace').prop('disabled',true);
        $('#text').prop('disabled',true);

        const sortImg = $("#sortOrder");

        const setOrderImg = ()=>{

            let sort = this.model.get("sortorder");

            if(sort === "DESC"){
                sortImg.data("order", "DESC");
                sortImg[0].src = sortdesc;
                sortImg[0].title = "Sort Descending";
            }
            else{
                sortImg.data("order", "ASC");
                sortImg[0].src = sortasc;
                sortImg[0].title = "Sort Ascending";
             }
        }
       
        setOrderImg();

        sortImg.on("click", (e)=>{
            const sort = sortImg.data("order");

            if(sort === "ASC"){
                self.model.set("sortorder", "DESC", {silent: true})
            }
            else{
                self.model.set("sortorder", "ASC", {silent: true})
            }

            setOrderImg();
        });
    }

    enableAdvancedSectionArea() {

        if (this.model.get('ValueOfAField') !== ''){
            $(`input[value='advance']`).prop('disabled',false);
        }

        if (this.model.get('function') === 'Sort'){
            this.enableSortFx();
            this.enableSortOptions(false);
        }
        else{
            $('#sortby').prop('disabled',true);
            $('#replace').prop('disabled',true);
            $('#text').prop('disabled',false);
            $("#sortOrder").off();
        }

        if (this.model.get('function') === 'Replace'){
            $('#replace').prop('disabled',false);
        }
       
        this.fillColumnsSelect();
    }

    fillColumnsSelect(){
        var options = $('#column');
        options.empty();
        options.html(' <option disabled selected value></option>');

        if (this.columnList) {
            this.columnList.map(function (column, columnId) {
                utils.appendOptionToSelect(options, column.attributes.id, column.attributes.name, false);
            });
        }
    }

    getParameter(paramName) {
        const prop = this.model.get('Parameters');
        let paramId = this.model.get(paramName);
        let parameter = _.find(prop.Parameter, function(obj) { return obj.id === paramId });

        if(!parameter){
            parameter = { id: this.modelField, type: 'expression', literal: 'null', field: 'null', special: 'stage'};
            this.model.get('Parameters').Parameter.push(parameter);
        }
       
        return parameter;
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        let ParamName = '';
        if (ev.currentTarget.id === 'addRowScreen') {
            ParamName = 'addTableRows';
        }else
        if (ev.currentTarget.id === 'text') {
            ParamName = 'text';
        }else
        if (ev.currentTarget.id === 'replace') {
            ParamName = 'replacetext';
        }

        let  attributes = {};
        const parameter = this.getParameter(ParamName);
        attributes = {formulaParameter: parameter.Expression, ParamName };

        var sfModal = new formulaModal({model: new Model(attributes), config: {selected: ''}});
        sfModal.render().then((formulaParameter)=>{
            //  Also change the creation of the modal passing the appropiated value on the config
            parameter.Expression = formulaParameter;
            parameter.id = formulaParameter.id;

            this.model.set(ParamName, formulaParameter.id, {silent: true});
        }).catch(err => console.log(err));
    }

    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.enableSelectionArea();
        this.enableAdvancedSectionArea();

        let selectedOption = this.model.get('action');
        let selectedSubOption = '';
        if (selectedOption) {
            if (selectedOption.substring(0,3) === 'add') {
                selectedSubOption = selectedOption.substring(3);
                selectedOption = 'add';
            }
            if (selectedOption.substring(0,4) === 'move') {
                selectedSubOption = selectedOption.substring(4);
                selectedOption = 'move';
            }
        }

        $('input[value=' + selectedOption + ']').prop('checked',true);

        switch(selectedOption){
            case 'add':
                $('input[value=' + selectedSubOption + ']').prop('checked',true);
                break;
            case 'move':
                $('input[value=' + selectedSubOption + ']').prop('checked',true);
                break;
            case 'deleteCurrent':
                $(`input[name='askForConfirmation']`).prop('checked',utils.isTrue(this.model.get('confirmation')));
                break;
            case 'advance':
                if (this.model.get('function')) {
                    $(`option[value=${this.model.get('function')}]`).attr('selected', true);
                }
                if (this.model.get('sortby')) {
                    $(`option[value=${this.model.get('sortby')}]`).attr('selected', true);
                }
                if (this.model.get('columnId')) {
                    $('#column').find(`option[value=${listService.cleanId( this.model.get('columnId') )}]`).attr('selected', true);
                }
                break;
        }


        this.delegateEvents();
        return this;
    }

}

export default MainTableActionView;
